import React, { useMemo } from 'react';
import { useStoreon } from 'storeon/react';
import { State } from 'store/types';
import { UseCityPickerStateReturnType, useRegions } from 'components/header/hooks';
import { HeaderModelData } from 'types/model';
import { Drawer, DrawerHeader, DrawerContent, DrawerFooter } from 'common/components/left-drawer';
import { useCitiesSuggestions } from 'common/hooks';
import { Typography } from 'fronton-react';
import { headerBackBtn } from 'components/header/styles/common';
import { useTranslation } from 'react-i18next';
import { footer, content, title } from './styles';
import { RegionsSearch } from './region-search';
import { RegionsSeo } from './regions-seo';
import { MenuContentLayer } from '../menu-content-layer';
import { getRegionsWithPagePathname } from './utils';

interface RegionsMenuProps extends UseCityPickerStateReturnType {
  model: HeaderModelData;
}

export const RegionsMenu = (props: RegionsMenuProps) => {
  const { show, onMenuClose, model } = props;
  const { regions } = useRegions(model);
  const { path: pathname } = useStoreon<State>('path');

  const regionsWithPagePathname = useMemo(
    () => getRegionsWithPagePathname(regions, pathname),
    [regions, pathname],
  );

  const { t } = useTranslation();

  const [suggestions, setSuggestions, hasRegionNumberChanged, filteredCitiesList] =
    useCitiesSuggestions(regions);

  return (
    <>
      <Drawer onClose={onMenuClose} show={show} data-qa="region-menu">
        <DrawerHeader className={headerBackBtn} title="" onClickBack={onMenuClose} />
        <DrawerContent className={content}>
          <MenuContentLayer horizontal className={title}>
            <Typography as="div" variant="h3">
              {t('header.main.region-popup.choose')}
            </Typography>
          </MenuContentLayer>
          <RegionsSearch
            regions={regions}
            suggestions={suggestions}
            setSuggestions={setSuggestions}
            hasRegionNumberChanged={hasRegionNumberChanged}
            filteredCitiesList={filteredCitiesList}
          />
        </DrawerContent>
        <DrawerFooter sticky className={footer} />
      </Drawer>
      <RegionsSeo regions={regionsWithPagePathname} />
    </>
  );
};
